import React, { memo } from "react";
import { CONNECTION_STATUS } from "../../../../constants/connectLMS";
import "../ConnectLMSPage.scss";
import ConnectionSettingsButton from "../button/ConnectionSettingsButton";
import RegenerateKeysButton from "../button/RegenerateKeysButton";


const LMSItemFunctions = memo(({ connection = {} }) => {
  return (
    <div className="functions-wrapper">
        <ConnectionSettingsButton connection={connection} />
        <RegenerateKeysButton/>
    </div>
  );
});

export default LMSItemFunctions;
